import { Navigate, Route, Routes } from "react-router-dom";
import LandingPage from "./Pages/LandingPage";
import LoginPage from "./Pages/LoginPage";
import LogoutPage from "./Pages/LogoutPage";
import DashboardPage from "./Pages/Dashboard";
import EvaluationPage from "./Pages/EvaluationPage";
import EvaluationInProgressPage from "./Pages/EvaluationInProgressPage";
import EvaluationErrorPage from "./Pages/EvaluationErrorPage";
import CompaniesPage from "./Pages/CompaniesPage";
import ProfilePage from "./Pages/ProfilePage";
import CreateCompanyPage from "./Pages/CreateCompanyPage";
import QuestionListPage from "./Pages/CreateQuestionsListPage";
import MyQuestionsPage from "./Pages/MyQuestionsPage";
import SingleQuestionListPage from "./Pages/SingleQuestionListPage";
import CertCategoryPage from "./Pages/CertCategoryPage";
import CertAllCategoriesPage from "./Pages/CertAllCategoriesPage";
import CreateWorkspacePage from "./Pages/CreateWorkspacePage";
import ViewAllWorkspacesPage from "./Pages/ViewWorkspacePage";
import ViewSingleWorkspacesPage from "./Pages/SingleWorkspacePage";
import ExpertFormPage from "./Pages/ExpertFormPage";
import KnowledgeBaseAllPage from "./Pages/KnowledgeBaseAllPage";
import KnowledgeBasePage from "./Pages/KnowledgeBasePage";
import UsersPage from "./Pages/UsersPage";
import CreateUserPage from "./Pages/CreateUserPage";
import UserProfilePage from "./Pages/UserProfilePage";
import PasswordResetRequestPage from "./Pages/PasswordResetRequest";
import PasswordResetSubmitPage from "./Pages/PasswordResetSubmit";
import PageNotFound from "./Components/PageNotFound";
import UnauthorizedPage from "./Pages/UnauthorizedPage";
import withAuth from "./Components/Common/WithAuth";
import RequireFeature from "./Components/Common/RequireFeature";
import RequireAnyFeature from "./Components/Common/RequireAnyFeature";
import { Features } from "./Enums/companyStatus";
import ActionLogPage from "./Pages/ActionLogPage";
import EntityPage from "./Pages/EntityPage";
import HomePage from "./Pages/HomePage";
import AlanCredentialsAllPage from "./Pages/AlanAllCredentialsPage";
import AlanCredentialCreatePage from "./Components/AlanCredentials/AlanCredentialCreatePage";
import QueueLoadMonitoringPage from "./Pages/QueueLoadMonitoringPage";
import DatabaseMonitoringPage from "./Pages/DatabaseMonitoringPage";
import AuthMonitoringPage from "./Pages/AuthMonitoringPage";
import ErrorMonitoringPage from "./Pages/ErrorMonitoringPage";
import AgentMonitoringPage from "./Pages/AgentMonitoringPage";
import HardwareMonitoringPage from "./Pages/HardwareMonitoringPage";
import RetrievalTestPage from "./Pages/RetrievalTestPage";
import GridSearchTestPage from "./Pages/GridSearchTestPage";
import ComoExpertsChatPage from "./Pages/ComoExpertsChatPage";
import ComoAgentsListPage from "./Pages/ComoAgentsListPage";
import ComoAgentFormPage from "./Pages/ComoAgentFormPage";
import McpConnectionsListPage from "./Pages/McpConnectionsListPage";
import McpConnectionFormPage from "./Pages/McpConnectionFormPage";
import ScheduledTasksListPage from "./Pages/ScheduledTasksListPage";
import ScheduledTaskFormPage from "./Pages/ScheduledTaskFormPage";
import GradingCriteriaAllPage from "./Components/GradingCriteria/GradingCriteriaAll";
import GradingCriterionCreatePage from "./Components/GradingCriteria/GradingCriteria";
import SkillsListPage from "./Pages/SkillsListPage";
import SkillFormPage from "./Pages/SkillFormPage";
import UsagePage from "./Pages/UsagePage";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import FeatureCatalogPage from "./Pages/FeatureCatalogPage";
import VoicesLayout from "./Components/Voices/Navigation/VoicesLayout";
import { VOICES_FEATURES } from "./Components/Voices/Navigation/voicesNavigation";
import VoicesTodayPage from "./Pages/VoicesTodayPage";
import VoicesCampaignsPage from "./Pages/VoicesCampaignsPage";
import VoicesCampaignPage from "./Pages/VoicesCampaignPage";
import VoicesPostsPage from "./Pages/VoicesPostsPage";
import VoicesCalendarPage from "./Pages/VoicesCalendarPage";
import VoicesEngagePage from "./Pages/VoicesEngagePage";
import VoicesResultsPage from "./Pages/VoicesResultsPage";
import VoicesUsagePage from "./Pages/VoicesUsagePage";
import VoicesPeoplePage from "./Pages/VoicesPeoplePage";
import VoicesProfilePage from "./Pages/VoicesProfilePage";
import VoicesSettingsPage from "./Pages/VoicesSettingsPage";
import HelpDeskAdminPage from "./Pages/HelpDeskAdminPage";
import HelpDeskUserPage from "./Pages/HelpDeskUserPage";
import AmbassadorLayout, {
  AmbassadorIndex,
} from "./Components/Ambassador/AmbassadorLayout";
import { AMBASSADOR_FEATURES } from "./Components/Ambassador/Common/ambassadorNavigation";
import AmbassadorDashboardPage from "./Pages/AmbassadorDashboardPage";
import AmbassadorMyDealsPage from "./Pages/AmbassadorMyDealsPage";
import AmbassadorDealFormPage from "./Pages/AmbassadorDealFormPage";
import AmbassadorDealPage from "./Pages/AmbassadorDealPage";
import AmbassadorNewsPage from "./Pages/AmbassadorNewsPage";
import AmbassadorNewsItemPage from "./Pages/AmbassadorNewsItemPage";
import AmbassadorInboxPage from "./Pages/AmbassadorInboxPage";
import AmbassadorAllDealsPage from "./Pages/AmbassadorAllDealsPage";
import AmbassadorDealReviewPage from "./Pages/AmbassadorDealReviewPage";
import AmbassadorNewsManagementPage from "./Pages/AmbassadorNewsManagementPage";
import DocumentCraftingLayout from "./Components/DocumentCrafting/DocumentCraftingLayout";
import { DOCUMENT_CRAFTING_FEATURES } from "./Components/DocumentCrafting/Common/documentCraftingNavigation";
import DocumentCraftingListPage from "./Pages/DocumentCraftingListPage";
import DocumentCraftingCreatePage from "./Pages/DocumentCraftingCreatePage";
import DocumentCraftingDetailPage from "./Pages/DocumentCraftingDetailPage";
import DocumentCraftingRevisePage from "./Pages/DocumentCraftingRevisePage";
import DocumentCraftingRunPage from "./Pages/DocumentCraftingRunPage";
import DocumentCraftingSettingsPage from "./Pages/DocumentCraftingSettingsPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />

      {/* PROTECTED ROUTES */}
      <Route
        element={withAuth({
          Component: DashboardPage,
          fallbackPath: "/logout",
        })}
      >
        <Route path="/home" element={<HomePage />} />
        <Route path="/evaluation" element={<EvaluationPage />} />
        <Route
          path="/evaluation_in_progress/:evaluationId"
          element={<EvaluationInProgressPage />}
        />
        <Route path="/evaluation_error" element={<EvaluationErrorPage />} />
        <Route element={<RequireFeature feature={Features.ENTITY_CREATION} />}>
          <Route path="entity/:companyId" element={<EntityPage />} />
          <Route path="entity" element={<CompaniesPage />} />
          <Route path="/entity/create" element={<CreateCompanyPage />} />
        </Route>
        <Route path="profile" element={<ProfilePage />} />
        <Route path="/question_list" element={<QuestionListPage />} />
        <Route path="/questions_list" element={<MyQuestionsPage />} />
        <Route
          path="/question_list/:listId"
          element={<SingleQuestionListPage />}
        />
        <Route path="/como-experts" element={<ComoExpertsChatPage />} />
        <Route
          path="/como-experts/:conversationId"
          element={<ComoExpertsChatPage />}
        />
        <Route path="/expert-form" element={<ExpertFormPage />} />
        <Route path="/help-desk-admin" element={<HelpDeskAdminPage />} />
        <Route path="/help-desk" element={<HelpDeskUserPage />} />

        <Route element={<RequireAnyFeature features={VOICES_FEATURES} />}>
          <Route path="/voices" element={<VoicesLayout />}>
            <Route index element={<Navigate to="today" replace />} />
            <Route path="today" element={<VoicesTodayPage />} />
            <Route path="campaigns" element={<VoicesCampaignsPage />} />
            <Route
              path="campaigns/:campaignId"
              element={<VoicesCampaignPage />}
            />
            <Route path="posts" element={<VoicesPostsPage />} />
            <Route path="calendar" element={<VoicesCalendarPage />} />
            <Route path="engage" element={<VoicesEngagePage />} />
            <Route path="results" element={<VoicesResultsPage />} />
            <Route
              element={
                <RequireAnyFeature
                  features={[Features.VOICES_POSTING]}
                  fallbackPath="/voices/today"
                />
              }
            >
              <Route path="profile" element={<VoicesProfilePage />} />
            </Route>
            <Route
              element={
                <RequireAnyFeature
                  features={[Features.VOICES_MARKETING]}
                  fallbackPath="/voices/today"
                />
              }
            >
              <Route path="people" element={<VoicesPeoplePage />} />
              <Route path="usage" element={<VoicesUsagePage />} />
              <Route path="settings" element={<VoicesSettingsPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="/features_catalog" element={<FeatureCatalogPage />} />

        <Route element={<RequireAnyFeature features={AMBASSADOR_FEATURES} />}>
          <Route path="/ambassador" element={<AmbassadorLayout />}>
            <Route index element={<AmbassadorIndex />} />
            <Route path="news" element={<AmbassadorNewsPage />} />
            <Route path="news/:newsId" element={<AmbassadorNewsItemPage />} />
            <Route
              element={
                <RequireAnyFeature
                  features={[Features.AMBASSADOR]}
                  fallbackPath="/ambassador"
                />
              }
            >
              <Route path="dashboard" element={<AmbassadorDashboardPage />} />
              <Route path="deals" element={<AmbassadorMyDealsPage />} />
              <Route path="new-deal" element={<AmbassadorDealFormPage />} />
              <Route path="deals/:dealId" element={<AmbassadorDealPage />} />
              <Route
                path="deals/:dealId/edit"
                element={<AmbassadorDealFormPage />}
              />
            </Route>
            <Route
              element={
                <RequireAnyFeature
                  features={[Features.AMBASSADOR_DEAL_MANAGEMENT]}
                  fallbackPath="/ambassador"
                />
              }
            >
              <Route path="manage/inbox" element={<AmbassadorInboxPage />} />
              <Route path="manage/deals" element={<AmbassadorAllDealsPage />} />
              <Route
                path="manage/deals/:dealId"
                element={<AmbassadorDealReviewPage />}
              />
            </Route>
            <Route
              element={
                <RequireAnyFeature
                  features={[Features.AMBASSADOR_NEWS]}
                  fallbackPath="/ambassador"
                />
              }
            >
              <Route
                path="manage/news"
                element={<AmbassadorNewsManagementPage />}
              />
            </Route>
          </Route>
        </Route>

        <Route
          element={<RequireAnyFeature features={DOCUMENT_CRAFTING_FEATURES} />}
        >
          <Route path="/document-crafting" element={<DocumentCraftingLayout />}>
            <Route index element={<DocumentCraftingListPage />} />
            {/* ?type=<key>&duplicate=<documentId>:<revisionId> */}
            <Route path="new" element={<DocumentCraftingCreatePage />} />
            <Route path="settings" element={<DocumentCraftingSettingsPage />} />
            <Route path="runs/:runId" element={<DocumentCraftingRunPage />} />
            {/* ?revision=<number> */}
            <Route
              path=":documentId"
              element={<DocumentCraftingDetailPage />}
            />
            {/* ?base=<revisionId> */}
            <Route
              path=":documentId/revise"
              element={<DocumentCraftingRevisePage />}
            />
          </Route>
        </Route>
      </Route>

      {/* ADMIN PROTECTED ROUTES */}
      <Route
        path="/"
        element={withAuth({
          Component: DashboardPage,
          fallbackPath: "/unauthorized",
          admin: true,
        })}
      >
        <Route path="/admin-dashboard" element={<AdminDashboard />} />

        <Route path="users" element={<UsersPage />} />
        <Route path="/users/create" element={<CreateUserPage />} />
        <Route path="/user/:userId" element={<UserProfilePage />} />

        <Route path="/workspace/create/" element={<CreateWorkspacePage />} />
        <Route path="/workspace/" element={<ViewAllWorkspacesPage />} />
        <Route
          path="/workspace/:workspaceId"
          element={<ViewSingleWorkspacesPage />}
        />

        <Route path="/cert_category" element={<CertAllCategoriesPage />} />
        <Route path="/cert_category/create" element={<CertCategoryPage />} />
        <Route
          path="/cert_category/edit/:certCategoryId"
          element={<CertCategoryPage />}
        />

        <Route path="/knowledge_base/" element={<KnowledgeBaseAllPage />} />
        <Route path="/knowledge_base/create" element={<KnowledgeBasePage />} />
        <Route
          path="/knowledge_base/edit/:knowledgeBaseId"
          element={<KnowledgeBasePage />}
        />
        <Route path="/alan_credentials" element={<AlanCredentialsAllPage />} />
        <Route
          path="/alan_credentials/create"
          element={<AlanCredentialCreatePage />}
        />
        <Route path="/grading_criterion" element={<GradingCriteriaAllPage />} />
        <Route
          path="/grading_criterion/create"
          element={<GradingCriterionCreatePage />}
        />
        <Route
          path="/grading_criterion/edit/:gradingCriterionId"
          element={<GradingCriterionCreatePage />}
        />
        <Route path="/action_log" element={<ActionLogPage />} />
        <Route path="/queue_monitoring" element={<QueueLoadMonitoringPage />} />
        <Route path="/db_monitoring" element={<DatabaseMonitoringPage />} />
        <Route path="/auth_monitoring" element={<AuthMonitoringPage />} />
        <Route path="/error_monitoring" element={<ErrorMonitoringPage />} />
        <Route path="/agent_monitoring" element={<AgentMonitoringPage />} />
        <Route
          path="/hardware_monitoring"
          element={<HardwareMonitoringPage />}
        />
        <Route path="/como_agents" element={<ComoAgentsListPage />} />
        <Route path="/como_agents/create" element={<ComoAgentFormPage />} />
        <Route
          path="/como_agents/edit/:agentId"
          element={<ComoAgentFormPage />}
        />
        <Route path="/skill/" element={<SkillsListPage />} />
        <Route path="/skill/create" element={<SkillFormPage />} />
        <Route path="/skill/edit/:skillId" element={<SkillFormPage />} />
        <Route path="/mcp_connections" element={<McpConnectionsListPage />} />
        <Route
          path="/mcp_connections/create"
          element={<McpConnectionFormPage />}
        />
        <Route
          path="/mcp_connections/edit/:connectionId"
          element={<McpConnectionFormPage />}
        />
        <Route path="/scheduled_tasks" element={<ScheduledTasksListPage />} />
        <Route
          path="/scheduled_tasks/create"
          element={<ScheduledTaskFormPage />}
        />
        <Route
          path="/scheduled_tasks/edit/:taskId"
          element={<ScheduledTaskFormPage />}
        />
        <Route path="/retrieval_test" element={<RetrievalTestPage />} />
        <Route path="/grid_search_test" element={<GridSearchTestPage />} />
        <Route path="/usage" element={<UsagePage />} />
      </Route>

      <Route
        path="/password-reset-request"
        element={<PasswordResetRequestPage />}
      />
      <Route path="/password-reset" element={<PasswordResetSubmitPage />} />

      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;
